import type { PreviewMeetingCubit } from '../../PreviewMeetingCubit'
import { PreviewDataFetcher } from './PreviewDataFetcher'

export class SeededPreviewDataFetcher extends PreviewDataFetcher {
  constructor(meeting: PreviewMeetingCubit) {
    super(meeting)
  }

  async start() {
    if (this.previewMeeting._slideDeckPreviewData) {
      this.meeting.slideDeck.replaceModel(
        this.previewMeeting._slideDeckPreviewData.slideDeck
      )
      this.meeting.slideDeckExhibits.replaceModels(
        this.previewMeeting._slideDeckPreviewData.slideDeckExhibits
      )
      this.meeting.slideDeckSlides.replaceModels(
        this.previewMeeting._slideDeckPreviewData.slideDeckSlides
      )
      this.meeting.slideDeckQuestions.replaceModels(
        this.previewMeeting._slideDeckPreviewData.slideDeckQuestions
      )
      this.fetchSettingsProcessingVideo()
      return
    }
    super.start()
  }
}
